import { IParamsTable } from '~/interfaces/IParamsTable';
import { authFetch } from '~/services/fetch';
import IWorkShift from '../interfaces/IWorkShift';
import { IUpdateProps } from '~/interfaces/IUpdateProps';

export async function getWorkShiftById(id: IUpdateProps) {
  const response = await authFetch({
    url: `/work-shift/${id}`,
    method: 'GET',
  });
  return response.data;
}

export async function getWorkShifts({
  filters = [],
  limit = 100000,
  orders = [{ field: 'name', sort: 'asc' }],
  name,
}: IParamsTable & { readonly name?: string; readonly work_hours?: number } = {}) {
  const response = await authFetch({
    url: '/work-shift',
    method: 'POST',
    data: {
      filters,
      orders,
      limit,
      name,
    },
  });
  return response.data;
}

export async function createWorkShift(data: Omit<IWorkShift, 'id'>) {
  const response = await authFetch({
    url: '/work-shift',
    method: 'POST',
    data,
  });
  return response.data;
}

export async function updateWorkShift(id: IUpdateProps, data: IWorkShift) {
  const response = await authFetch({
    url: `/work-shift/${id}`,
    method: 'PUT',
    data,
  });
  return response.data;
}

export async function deleteWorkShift(id: number) {
  const response = await authFetch({
    url: `/work-shift/${id}`,
    method: 'DELETE',
  });
  return response.data;
}